import React from 'react';
import { Popover, PopoverContent, PopoverTrigger } from 'src/components/ui/popover';
import { Button } from 'src/components/ui/button';
import { WarningPopover } from 'src/components/WarningPopower/WarningPopover';

const TriggerSvg = () => {
  return (
    <svg width="4" height="20" viewBox="0 0 4 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="1.99997" cy="1.99997" r="1.99997" fill="#05050D" fillOpacity="0.3" />
      <circle cx="1.99997" cy="10.0001" r="1.99997" fill="#05050D" fillOpacity="0.3" />
      <circle cx="1.99997" cy="18" r="1.99997" fill="#05050D" fillOpacity="0.3" />
    </svg>
  );
};

export const SettingsPopoverButton = ({ disabledByPermision = false, content }) => {
  const [open, setOpen] = React.useState(false);

  return (
    <div className={'relative'}>
      <Popover modal={false} open={open} onOpenChange={(openState) => setOpen(openState)}>
        <PopoverTrigger
          asChild
          disabled={disabledByPermision}
          onClick={(e) => {
            e.preventDefault();
            setOpen((prev) => !prev);
          }}
        >
          <Button variant="ghost">
            <TriggerSvg />
          </Button>
        </PopoverTrigger>
        <PopoverContent
          sideOffset={-20}
          align="end"
          alignOffset={30}
          className="min-w-[170px] shadow transition backdrop-blur rounded-sm-5 w-max h-max px-0 py-0 flex flex-col overflow-hidden"
        >
          {content}
        </PopoverContent>
      </Popover>
      {disabledByPermision && (
        <WarningPopover triggerClassName="absolute -right-2 -top-2" fill="black" />
      )}
    </div>
  );
};
